<app-base-inline-form
  [header]="header()"
  [fields]="fields()"
  [leftHeader]="leftHeader()"
  [model]="model()"
  [submitIcon]="submitIcon()"
  [submitText]="submitText()"
  (submitted)="submittedEvent.emit($event)"
></app-base-inline-form>

<app-grid
  gridCssClass="tab-grid {{ gridCssClass() }}"
  [stateKey]="gridStateKey"
  [columnDefs]="columnDefs()"
  [pagination]="pagination()"
  [rowData]="rowData()"
  [multiSelectRows]="multiSelectRows()"
  [showDelete]="showDelete()"
  [showDeleteMessage]="showDeleteMessage()"
  [showDiscard]="showDiscard()"
  [showPrint]="showPrint()"
  [sortable]="sortable()"
  [filter]="filter()"
  [importService]="importService()"
  [suppressScrollOnNewData]="suppressScrollOnNewData()"
  (edit)="edit.emit($event)"
  (delete)="delete.emit($event)"
  (rowSelected)="rowSelected.emit($event)"
  (print)="print.emit($event)"
  (save)="save.emit()"
  (imported)="imported.emit()"
></app-grid>
